import { computed } from 'vue'

import type { Location } from '@/types'

export const daysForLocale = ( localeName = 'nl-NL', weekday: 'narrow' | 'short' | 'long' = 'long' ) => {
	const { format } = new Intl.DateTimeFormat( localeName, { weekday } )
	return [ ...Array( 7 ).keys() ].map( ( day ) => format( new Date( Date.UTC( 2021, 5, day ) ) ) )
}

export const openingHours = computed( () => ( location: Location ) => {
	return location.opening_hours.map( ( hours: any ) => {
		const day = daysForLocale()[ hours.day_of_week % 7 ]

		return {
			day,
			hours: `${ hours.opens ? hours.opens : 'gesloten' } ${ hours.closes ? '- ' + hours.closes : '' }`
		}
	} )
} )

export function calculateDistance( lat1: number, lon1: number, lat2: number, lon2: number ) {
	const R = 6371
	const dLat = ( lat2 - lat1 ) * ( Math.PI / 180 )
	const dLon = ( lon2 - lon1 ) * ( Math.PI / 180 )

	const lat1Rad = lat1 * ( Math.PI / 180 )
	const lat2Rad = lat2 * ( Math.PI / 180 )

	const a = Math.sin( dLat / 2 ) * Math.sin( dLat / 2 ) + Math.cos( lat1Rad ) * Math.cos( lat2Rad ) * Math.sin( dLon / 2 ) * Math.sin( dLon / 2 )
	const c = 2 * Math.atan2( Math.sqrt( a ), Math.sqrt( 1 - a ) )

	const distance = R * c
	return distance
}
